import React from 'react';
import { Navbar } from '../../components';
import { FellowTrainingHeader } from '../../containers';

const FellowTraining = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <FellowTrainingHeader />
        </div>
    </div>
  )
}

export default FellowTraining